import { create } from 'zustand';
import { getGroupSchedule, setGroupSchedule, getStudentSchedule, setStudentSchedule, getActualStudentSchedule, getAllSchedulesForWeek, deleteStudentSchedule, deleteGroupSchedule } from '../api';
import useAdminAuthStore from './adminAuthStore';
import useAuthStore from './authStore';

const useScheduleStore = create((set, get) => ({
  groupSchedule: [],
  studentSchedule: [],
  actualSchedule: [],
  allSchedules: [],
  loading: false,
  error: null,

  async fetchGroupSchedule({ groupId, week, startDate, endDate }) {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const data = await getGroupSchedule({ groupId, week, startDate, endDate, token });
      set({ groupSchedule: data, loading: false });
      return data;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  async saveGroupSchedule(params) {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const data = await setGroupSchedule({ ...params, token });
      set({ loading: false });
      return data;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  async fetchStudentSchedule({ studentId, week, startDate, endDate }) {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const data = await getStudentSchedule({ studentId, week, startDate, endDate, token });
      set({ studentSchedule: data, loading: false });
      return data;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  async saveStudentSchedule({ studentId, week, dayOfWeek, timeSlots, date }) {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const data = await setStudentSchedule({ studentId, week, dayOfWeek, timeSlots, date, token });
      set({ loading: false });
      return data;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  async fetchActualStudentSchedule({ studentId, groupId, week, startDate, endDate }) {
    set({ loading: true, error: null });
    try {
      const { token } = useAuthStore.getState();
      const data = await getActualStudentSchedule({ studentId, groupId, week, startDate, endDate, token });
      set({ actualSchedule: data, loading: false });
      return data;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  async fetchAllSchedulesForWeek({ week, startDate, endDate }) {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const data = await getAllSchedulesForWeek({ week, startDate, endDate, token });
      set({ allSchedules: data, loading: false });
      return data;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  async deleteStudentSchedule({ studentId, week, dayOfWeek, date, startTime, endTime }) {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const data = await deleteStudentSchedule({ studentId, week, dayOfWeek, date, startTime, endTime, token });
      set({ loading: false });
      return data;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  async deleteGroupSchedule({ groupId, week, dayOfWeek, date, startTime, endTime }) {
    set({ loading: true, error: null });
    try {
      const { token } = useAdminAuthStore.getState();
      const data = await deleteGroupSchedule({ groupId, week, dayOfWeek, date, startTime, endTime, token });
      set({ loading: false });
      return data;
    } catch (e) {
      set({ error: e.message, loading: false });
      throw e;
    }
  },

  clear() {
    set({ groupSchedule: [], studentSchedule: [], actualSchedule: [], error: null });
  }
}));

export default useScheduleStore; 